import { gql } from '@apollo/client';

const getSellerInputQuery = gql`
  query GetCustomerUuidForSellerInput($sellerInputUUID: String!) {
    reception {
      getSellerInput(input: { uuid: $sellerInputUUID }) {
        sellerInput {
          customerUuid
        }
      }
    }
  }
`;

export default getSellerInputQuery;
